import React from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./protedctedRoute";
import PrivatedRoutes from "./privatedRoute";
import Error404 from "../Pages/Error404";
import Login from "../Pages/Login";
import Lablist from "../Pages/Lablist";
import UsersList from "../Pages/UsersList";
import UserGroupList from "../Pages/UserGroupList";
import LabDetail from "../Pages/LabDetail";
import Setting from "../Pages/Setting";
import DepartmentList from "../Pages/DepartmentList";
import LabFormList from "../Pages/LabFormList";
import LoginLine from "../Pages/LoginLine";
import DefaultUser from "../Pages/DefaultUser";

export default function RoutePage() {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoutes />}>
        <Route index element={<Login />} />
        <Route path="/login/line" element={<LoginLine />} />
      </Route>

      <Route path="/defaultUser" element={<PrivatedRoutes />}>
        <Route index element={<DefaultUser />} />
      </Route>

      <Route path="/lab" element={<PrivatedRoutes />}>
        <Route index element={<Lablist />} />
        <Route path="detail/:id" element={<LabDetail />} />
        <Route path="users" element={<UsersList />} />
        <Route path="user-group" element={<UserGroupList />} />
        <Route path="setting" element={<Setting />} />
        <Route path="department" element={<DepartmentList />} />
        <Route path="lab-form" element={<LabFormList />} />
        {/* <Route path="dashboard" element={<DasPage />} />
        <Route path="lablist/:type/:visit_id" element={<LabList />} />
        <Route path="patho" element={<PathoList />} />
        <Route path="detail/:type/:id" element={<LabDetail />} /> */}
      </Route>
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
